import { Browser } from '@capacitor/browser';

const InvoiceLink = ({ invoiceNumber }) => {

    const openLink = (event) => {
        const url = `https://iiaonline.in/invoices.php?inI=${invoiceNumber}`;
        Browser.open({ url });
      };
      
  return (
    <p onClick={openLink} style={{
        margin:0,
        color:'#cb202d',
        textDecoration:'underline',
        fontSize:12
    }}>
        Download Invoice
    </p> 
  );
};
export default InvoiceLink;